/* Magnify.js - Image Zoom Functions */
/* Wrapped in IIFE to prevent duplicate declaration errors on quick view */
(function() {
  'use strict';
  
  // Skip if already initialized (prevents duplicate execution)
  if (window._magnifyJsInitialized) return;
  window._magnifyJsInitialized = true;
  
  let overlay = null;
  let outboxContainer = null;

  /* ===== HOVER ZOOM (Original) ===== */
  function createOverlay(image) {
    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('src', `${image.src}`);
    overlay = document.createElement('div');
    prepareOverlay(overlay, overlayImage);
    overlayImage.onload = () => {
      image.parentElement.insertBefore(overlay, image);
      const zoomIcon = image.parentElement.parentElement.querySelector('.zoom-icon');
      if (zoomIcon) zoomIcon.classList.add('zoom-icon-minus');
    };

    return overlay;
  }
  function prepareOverlay(container, image) {
    container.setAttribute('class', 'image-magnify-full-size');
    container.setAttribute('aria-hidden', 'true');
    container.style.backgroundImage = `url('${image.src}')`;
    container.style.backgroundColor = 'var(--color-body-background, #fff)';
    container.style.backgroundRepeat = 'no-repeat';
  }
  function moveWithHover(image, event, zoomRatio) {
    const ratio = image.height / image.width;
    const container = event.target.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;
    const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    // 원본 계산식: 배율의 기준은 '화면에 보이는 폭'(image.width)이다.
    // naturalWidth(원본 파일 픽셀)를 쓰면 srcset·DPR 에 따라 실효 배율이 제멋대로 바뀌고,
    // 배경은 src(고정 1445w)인데 크기는 currentSrc 기준이라 확대본이 뭉개진다.
    overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }
  function magnify(image, zoomRatio) {
    const overlay = createOverlay(image);
    overlay.onclick = () => {
      overlay.remove();
      const zoomIcon = image.parentElement.parentElement.querySelector('.zoom-icon');
      if (zoomIcon) zoomIcon.classList.remove('zoom-icon-minus');
    }
    overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
    overlay.onmouseleave = () => {
      overlay.remove();
      const zoomIcon = image.parentElement.parentElement.querySelector('.zoom-icon');
      if (zoomIcon) zoomIcon.classList.remove('zoom-icon-minus');
    }
  }
  function enableZoomOnHover(zoomRatio) {
    const images = document.querySelectorAll('.image-magnify-hover');
    images.forEach((image) => {
      image.onclick = (event) => {
        magnify(image, zoomRatio);
        moveWithHover(image, event, zoomRatio);
      };
    });
  }

  /* ===== OUTBOX ZOOM (New Feature) ===== */
  function createOutboxZoom(image, zoomRatio) {
    // Find the product media container
    const mediaItem = image.closest('.product-media__item') || image.closest('.product__media').parentElement;
    
    if (!mediaItem) return null;
    
    // Create outbox container - append to body for fixed positioning
    outboxContainer = document.createElement('div');
    outboxContainer.setAttribute('class', 'image-zoom-outbox');
    outboxContainer.style.backgroundImage = `url('${image.src}')`;
    outboxContainer.style.backgroundRepeat = 'no-repeat';
    // hover 줌과 같은 기준(화면에 보이는 폭 × 배율)을 쓴다 — naturalWidth 기준이면
    // 화면 해상도에 따라 배율이 달라지고 확대본이 뭉개진다.
    outboxContainer.style.backgroundSize = `${image.width * zoomRatio}px ${image.height * zoomRatio}px`;
    
    // Create lens/cursor indicator
    const lens = document.createElement('div');
    lens.setAttribute('class', 'image-zoom-lens');
    
    // Append outbox to body for proper z-index stacking
    document.body.appendChild(outboxContainer);
    mediaItem.appendChild(lens);
    
    // Position outbox next to image
    positionOutbox(image, outboxContainer);
    
    return { outbox: outboxContainer, lens: lens };
  }

  function positionOutbox(image, outbox) {
    const imageRect = image.getBoundingClientRect();
    const outboxWidth = Math.min(500, window.innerWidth * 0.4);
    const outboxHeight = Math.min(500, window.innerHeight * 0.8);
    const gap = 20;
    
    // Check if there's space on the right
    const spaceOnRight = window.innerWidth - imageRect.right;
    const spaceOnLeft = imageRect.left;
    
    let left, top;
    
    if (spaceOnRight >= outboxWidth + gap) {
      // Position on the right
      left = imageRect.right + gap;
    } else if (spaceOnLeft >= outboxWidth + gap) {
      // Position on the left
      left = imageRect.left - outboxWidth - gap;
    } else {
      // Position on the right anyway
      left = imageRect.right + gap;
    }
    
    // Vertical centering with viewport bounds
    top = imageRect.top + (imageRect.height - outboxHeight) / 2;
    top = Math.max(10, Math.min(top, window.innerHeight - outboxHeight - 10));
    
    outbox.style.left = `${left}px`;
    outbox.style.top = `${top}px`;
    outbox.style.width = `${outboxWidth}px`;
    outbox.style.height = `${outboxHeight}px`;
  }

  function moveOutboxZoom(image, event, zoomRatio, outbox, lens) {
    const imageRect = image.getBoundingClientRect();
    
    // Calculate mouse position relative to image
    let xPos = event.clientX - imageRect.left;
    let yPos = event.clientY - imageRect.top;
    
    // Constrain to image bounds
    xPos = Math.max(0, Math.min(xPos, imageRect.width));
    yPos = Math.max(0, Math.min(yPos, imageRect.height));
    
    // Calculate percentage position
    const xPercent = (xPos / imageRect.width) * 100;
    const yPercent = (yPos / imageRect.height) * 100;
    
    // Update outbox background position
    outbox.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    
    // Update lens position and size
    const lensSize = Math.min(imageRect.width, imageRect.height) / zoomRatio;
    lens.style.width = `${lensSize}px`;
    lens.style.height = `${lensSize}px`;
    lens.style.left = `${xPos - lensSize / 2}px`;
    lens.style.top = `${yPos - lensSize / 2}px`;
  }

  function enableOutboxZoom(zoomRatio) {
    const images = document.querySelectorAll('.image-magnify-outbox');
    
    images.forEach((image) => {
      let zoomElements = null;
      
      image.addEventListener('mouseenter', (event) => {
        if (window.innerWidth <= 1024) return; // Disable on mobile/tablet
        
        zoomElements = createOutboxZoom(image, zoomRatio);
        if (zoomElements) {
          zoomElements.outbox.classList.add('active');
          zoomElements.lens.classList.add('active');
          const zoomIcon = image.parentElement.parentElement.querySelector('.zoom-icon');
          if (zoomIcon) zoomIcon.classList.add('zoom-icon-minus');
        }
      });
      
      image.addEventListener('mousemove', (event) => {
        if (zoomElements && window.innerWidth > 1024) {
          moveOutboxZoom(image, event, zoomRatio, zoomElements.outbox, zoomElements.lens);
        }
      });
      
      image.addEventListener('mouseleave', () => {
        if (zoomElements) {
          zoomElements.outbox.remove();
          zoomElements.lens.remove();
          zoomElements = null;
          const zoomIcon = image.parentElement.parentElement.querySelector('.zoom-icon');
          if (zoomIcon) zoomIcon.classList.remove('zoom-icon-minus');
        }
      });
    });
  }

  /* Initialize zoom functions — 배율은 원본(vanilla 3.4.0)과 동일한 2 */
  enableZoomOnHover(2);
  enableOutboxZoom(2);

  // Expose reinit function for dynamic content (Quick View)
  window.MagnifyJS = {
    reinit: function() {
      enableZoomOnHover(2);
      enableOutboxZoom(2);
    }
  };
})();
